var map = {
	"./Ck.svg": 60219,
	"./Kc.svg": 92939,
	"./Performance.svg": 97741,
	"./Setting.svg": 21171,
	"./Staff.svg": 9821,
	"./VIP.svg": 76946,
	"./Wechat.svg": 72975,
	"./ad.svg": 22930,
	"./audit.svg": 93142,
	"./business-setting.svg": 77492,
	"./business-summary.svg": 39600,
	"./check.svg": 87471,
	"./collapse.svg": 94472,
	"./commission.svg": 25034,
	"./coupon.svg": 8651,
	"./edit-amount.svg": 12534,
	"./expand.svg": 51865,
	"./export.svg": 65475,
	"./filter.svg": 57175,
	"./finance-report.svg": 87460,
	"./gallery.svg": 205,
	"./goods-other.svg": 73848,
	"./goods-price.svg": 73289,
	"./goods-produce.svg": 41813,
	"./goods-setting.svg": 32674,
	"./group.svg": 43174,
	"./help.svg": 7760,
	"./import.svg": 8454,
	"./inbound.svg": 16456,
	"./log.svg": 74193,
	"./member-marketing.svg": 67316,
	"./people.svg": 34952,
	"./print-setting.svg": 44801,
	"./report-setting.svg": 8716,
	"./revoke-audit.svg": 34489,
	"./room-holiday.svg": 5003,
	"./room-member.svg": 97091,
	"./room-price.svg": 43348,
	"./room-setting.svg": 8059,
	"./save.svg": 63722,
	"./seckill.svg": 29828,
	"./shift.svg": 87851,
	"./sms.svg": 74060,
	"./star.svg": 48637,
	"./stock-stats.svg": 98615,
	"./stock.svg": 15901,
	"./submit.svg": 53345,
	"./upload.svg": 29538,
	"./void.svg": 72167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;